export const initDeleteBtn = () => {
    $('[data-function="delete-record"]').unbind('click.delete-record').bind('click.delete-record', function(){
        console.log('initDeleteBtn');

        console.log($('#modal-delete'));

        let url = $(this).data('url');
        $('#modal-delete .modal-title').html('');
        $('#modal-delete .modal-body').html(spinnerHtml());
        $('#modal-delete').show();

        axios.get(url)
            .then(function (response) {

                console.log('response');

                $('#modal-delete .modal-content').html(response.data);
                $('#modal-delete input[name="_token"]').val($('meta[name="csrf-token"]').attr('content'));
            })
            .catch(function(error){
                $('#modal-delete .modal-content').html(
                    `<div class="alert alert-danger mb-0" role="alert">
                        Ein Fehler ist aufgetreten
                    </div>`);
            });
    });
}

// Set a modal as ajax form
export const modalAjaxForm = (modal, callback = function(){}) => {
    var form = modal.find('form');
    form.on('submit',function(event){
        event.preventDefault();

        var url = $(this).prop('action');
        var data = $(this).serialize();

        $(this).find('[type="submit"]').hide();
        modal.find('#modal-spinner').removeClass('d-none');

        axios.post(url, data)
            .then(function (response) {
                modal.hide();
                form.find('[type="submit"]').show();
                modal.find('#modal-spinner').addClass('d-none');

                callback(response.data);
            });
    });
}

export const spinnerHtml = () => {
    return '<div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>';
}